<template>
  <div class="purchase-container">
    <div class="header-container">
      <div class="header-content">
        <img src="/images/xoshlogo.png" />
        <h6>Xoshplay</h6>
        <h2>Welcome!</h2>
        <h2>Join The Adventure Today</h2>
      </div>
    </div>

    <div class="purchase-register">
      <form action="#" @submit.prevent="addsubscription" class="purchase-form">
        <div id="errorMessage" style="color:red;">{{ errorMessage }}</div>

        <label>Enter Your Phone Number</label>
        <div class="phone-number">
          <span>(BD) +88</span>
          <input type="text" v-model="phone" placeholder="Your Number" />
        </div>

        <button type="submit" class="submit-phone-btn" @click="addsubscription">
          CONTINUE
        </button>
      </form>
    </div>

    <p class="purchase-text">
      Unleash your gaming spirit with Xoshplay, the ultimate destination for
      fun, strategy, and challenges. Whether you’re a casual gamer or a
      competitive pro, Xoshplay offers a seamless gaming experience that keeps
      you hooked for hours.
    </p>
    <p class="purchase-text">
      Subscribe now for only 5 BDT + SC, VAT (If applicable)
    </p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PurchaseGP",
  data() {
    return {
      phone: "",
      errorMessage: "",
      isValidPhone: false,
      host: null
    };
  },
  created() {
    this.$root.mainWrapper = "wrapper-main-purchase";
  },
  methods: {
    validatePhone() {
      const phone = this.phone ? this.phone.trim() : "";
      const regex = /^(88017|88013|017|013)\d{8}$/;

      this.isValidPhone = regex.test(phone);

      if (!this.isValidPhone) {
        this.errorMessage =
          phone.length > 0
            ? "Please enter a valid Grameenphone number."
            : "Phone number cannot be empty.";
      } else {
        this.errorMessage = "";
      }
    },
    addsubscription() {
      this.validatePhone();

      if (!this.isValidPhone) return;

      this.host = this.$root.url();
      const phone = this.phone.trim();
      const path = "gpCharge";
      const url = `${this.host}/${path}?msisdn=${phone}&packageId=1`;

      axios
        .get(url)
        .then(response => {
          if (response.data.status_code === 200) {
            window.location.href = response.data.redirect_url;
          } else {
            this.errorMessage = response.data.message || "An error occurred";
          }
        })
        .catch(error => {
          console.log(error);
          this.errorMessage = "Something went wrong. Please try again.";
        });
    }
  }
};
</script>

<style scoped>
.purchase-container {
  display: block;
  height: 500px;
  background: linear-gradient(0deg, #181a21 24%, rgba(2, 7, 23, 0) 100%),
    url("/images/spa_banner.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center bottom 220px;
  background-size: 72% auto;
}

.header-container {
  position: relative;
  height: 500px;
  text-align: center;
}

.header-content {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.header-content img {
  height: 115px;
  width: 115px;
}

.header-content h6 {
  color: white;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 16px;
}

.header-content h2 {
  color: #44d62c;
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
}

.purchase-register {
  padding: 20px;
  margin-bottom: 10px;
}

.purchase-form {
  text-align: center;
}

.purchase-form label {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 30px;
}

.phone-number {
  margin-top: 12px;
  color: #888888;
  width: 100%;
  display: flex;
  align-items: center;
}

.phone-number span {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 2%;
  padding: 17px 10px;
  border: 1px solid #88888880;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.phone-number input {
  background: #8888881a;
  color: #fff;
  padding: 16px 10px;
  border: 0;
  flex-grow: 1;
  border: 1px solid #505155;
  border-width: 1px 1px 1px 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.submit-phone-btn {
  background: #44d62c;
  color: #181a21;
  font-size: 16px;
  font-weight: 700;
  padding: 12px 32px;
  text-transform: uppercase;
  border-radius: 4px;
  margin-top: 20px;
  border: 0;
}

.purchase-text {
  color: #ffffff4d;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  padding: 0 20px;
  text-align: center;
}

@media (max-width: 640px) {
  .purchase-container {
    background-size: 150% auto;
  }

  .header-container {
    height: 360px;
  }
}
</style>
